module.exports = __webpack_public_path__ + "static/screen-tasse-8075ba6fcfef3997ed37a2a3ddecbe20.png";